import { useCallback, useState } from "react";
import { Patient } from "../../../models/Patient";
import AccountRepository from "../../../repositories/AccountRepository";

export const useGetPatients = () => {
  const [data, setData] = useState<Patient[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const loadData = useCallback(async () => {
    setIsLoading(true);

    await AccountRepository.patient({
      with: ["photo"],
    })
      .then((response) => {
        const { data: responseData } = response.data;
        setData(responseData);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    data,
    isLoading,
    loadData,
  };
}
